export default function Terms() {
    return (
        <section className="py-10 px-10 text-sm">
            <h1 className="font-semibold text-2xl">Terms & Conditions</h1>
            <p>Welcome to <strong>Tech4All</strong>! By using our services, you agree to follow these terms:</p>

            <h2>Our services</h2>
            <ul className="text-xs">
                <li>Tech4All provides premium services for managing and optimizing your technology needs.</li>
                <li>Some features are paid. By purchasing, you agree to our pricing and refund policy.</li>
            </ul>

            <h2>Your responsibilities</h2>
            <ul className="text-xs">
                <li>Provide accurate information (name and email).</li>
                <li>Don’t use Tech4All for any illegal or harmful activities.</li>
            </ul>

            <h2>Payments</h2>
            <ul className="text-xs">
                <li>All payments are processed securely.</li>
                <li>Fees are non-refundable unless stated otherwise.</li>
            </ul>

            <h2>Changes to terms</h2>
            <p className="text-xs">We may update these terms occasionally. Continued use of our services means you agree to the changes.</p>
        </section>
    )
}